import {DateTime} from 'luxon';

const compare = (a: any, b: any) => {
  if (a > b) return +1;
  if (a < b) return -1;
  return 0;
};

const isNullOrUndefined = (value: unknown) =>
  value === null || value === undefined;

const getPreviousISODates = (
  startDate: Date = new Date(),
  numberOfDays: number = 30,
) => {
  const dates = [];

  for (let i = 0; i < numberOfDays; i++) {
    // Create a new date object for each day in the past
    const pastDate = new Date(startDate);
    pastDate.setDate(startDate.getDate() - i);

    // Convert the date to ISO format and add it to the array
    dates.push(DateTime.fromJSDate(pastDate).toFormat('yyyy-MM-dd'));
  }

  return dates;
};

const sanitizeFilename = (str: string) => {
  return (
    str
      .replaceAll(' ', '-')
      // eslint-disable-next-line no-control-regex
      .replace(/[<>:"/\\|?*\u0000-\u001F]/g, '')
      .trim()
  );
};

function truncateString(
  str: string,
  maxLength: number,
  ellipsis: string = '\u2026',
) {
  return str.length > maxLength ? str.slice(0, maxLength) + ellipsis : str;
}

export {
  compare,
  isNullOrUndefined,
  getPreviousISODates,
  truncateString,
  sanitizeFilename,
};
